import React, {useEffect, useState} from "react";
import ImageSlider from "./ImageSlider";
import useSound from "use-sound";

const LobbyRoom = ({
                       maxCapacity,
                       gameThumbnail,
                       pwsPlayers,
                       startPWSGame,
                       avatar,
                       name,
                       mode
                   }) => {
    const [playStrangerAudio, {stop: stopStrangerAudio}] = useSound(
        "/audio/stranger_match.mp3",
        {
            volume: 1,
            loop: true,
        },
    );
    useEffect(() => {
        playStrangerAudio()
    }, [playStrangerAudio])

    useEffect(() => {
        playStrangerAudio();
        return () => stopStrangerAudio();
    }, []);

    useEffect(() => {
        if (pwsPlayers.length > 0) {
            console.log("Stopping stranger audio...");
            stopStrangerAudio()
        }
    }, [pwsPlayers]);

    const [finalImages, setFinalImages] = useState(
        Array.from({length: maxCapacity}).map(() => {
            return "";
        }),
    );

    useEffect(() => {
        if (pwsPlayers.length === 0) return;
        const images = Array(maxCapacity).fill("");

        let index = 1;
        const interval = setInterval(() => {
            if (index < maxCapacity) {
                images[index - 1] = pwsPlayers[index - 1].avatar;
                setFinalImages([...images]);
                index++;
            } else {
                clearInterval(interval);
            }
        }, 1000);

        return () => clearInterval(interval);
    }, [pwsPlayers]);

    if (name.length === 0 || avatar.length === 0) {
        // TODO Error state
        return <h1>
            Invalid Params
        </h1>
    }
    return (
        <div
            className={`relative flex flex-col w-[100dvw] h-[100dvh] ${mode === "dark"? "bg-black": "bg-white"} sm:rounded-none rounded-none transition-all duration-200 ease-out overflow-hidden`}
        >
            <div className="absolute inset-0">
                <img
                    draggable="false"
                    src={gameThumbnail}
                    alt="Background"
                    className="w-full h-[25%] object-cover opacity-90"
                    style={{
                        filter: "blur(5px)",
                    }}
                />
            </div>
            <div className="w-full">
                <div className={"flex"}>
                    <div
                        className="absolute text-white items-center justify-between p-2 rounded-2xl top-[20vh] -translate-y-1/2 left-2 -translate-x-0.5">
                        <img
                            draggable={false}
                            src={gameThumbnail}
                            alt="game-logo"
                            className="w-16 h-16 md:w-24 md:h-24 rounded-2xl border-[6px] md:border-[10px] border-gray-900 "
                        />
                    </div>
                </div>
            </div>
            <div className={"flex flex-col items-center"}>
                <div
                    className="pt-0 gap-2 md:gap-6 no-scrollbar w-fit justify-center items-center px-4 grid grid-cols-2 [&>*]:rounded-lg absolute top-1/2 -translate-y-1/2 mx-auto">
                    {Array.from({length: maxCapacity}).map((_, i) => (
                        <div
                            key={i}
                            className={`flex flex-col justify-between bg-cover user-rtc-${i} w-[35vw] h-[35vw] md:w-48 md:h-48 relative`}
                            style={{
                                boxShadow: "inset 1px 1px 3px rgba(254, 254, 254, 0.2)",
                                backgroundImage: `url('/images/bg-${i}.png')`,
                            }}
                        >
                            <div className="flex flex-col justify-center mt-3 items-center mb-3 w-full h-full">
                                {i === 0 ? (
                                    <ImageSlider
                                        key={i}
                                        finalImage={avatar}
                                        startPWSGame={startPWSGame}
                                        isLast={i === maxCapacity - 1}
                                        playSound={false}
                                        startIndex={i}
                                    />
                                ) : (
                                    <ImageSlider
                                        key={i}
                                        finalImage={finalImages[i - 1]}
                                        startPWSGame={startPWSGame}
                                        isLast={i === maxCapacity - 1}
                                        playSound={true}
                                        startIndex={i}
                                    />
                                )}
                            </div>

                            {i === 0 && (
                                <span className="absolute w-full bottom-6 left-1/2 -translate-x-1/2 font-bold text-center">
                  {name}
                </span>
                            )}
                            {i !== 0 && finalImages[i - 1] && (
                                <span className="absolute w-full bottom-6 left-1/2 -translate-x-1/2 font-bold text-center">
                  {pwsPlayers[i - 1].name}
                </span>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default LobbyRoom;